<template>
  <el-dialog
    :visible.sync="visible"
    :title="'支付信息'"
	@close='closeDialog'
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true" width="750px">
		<span v-if="parentIsErr" style="color:red;display: block;text-align: center;margin-top: -30px;margin-bottom: 20px;">本次支付为交易失败重新支付，仅发放自由职业者应收金额，不计算综合服务费。</span>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="100px">
		<el-row type="flex" justify="space-between" v-for="item in payFormData" :key="item.id">
			<el-col :span="10">
				<el-form-item  label="姓名:">
					<el-input style="width: 100%;" disabled v-model="item.realName"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item  label="结算金额:">
					<el-input style="width: 100%;" disabled :value="item.dealMoney ? (item.dealMoney).toFixed(2) : ''"></el-input>
				</el-form-item>
			</el-col>
		</el-row>
		<el-row type="flex" justify="space-between" v-for="item in payFormData" :key="item.realName">
			<el-col :span="10">
				<el-form-item  label="服务费:">
					<el-input style="width: 100%;" disabled :value="item.serviceCharge ? (item.serviceCharge).toFixed(2) : ''"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item  label="企业承担金额:">
					<el-input style="width: 100%;" disabled :value="item.amountPayable ? (item.amountPayable).toFixed(2) : ''"></el-input>
				</el-form-item>
			</el-col>
		</el-row>
		<el-form-item prop="remark" label="备注:">
		  <el-input v-model="dataForm.payRemark" type="textarea" rows="4"></el-input>
		</el-form-item>
		<el-row type="flex" justify="space-between">
			<el-col :span="12">
				<el-form-item prop="paypass" label="支付密码:" label-width="100px">
					<el-input v-model="dataForm.paypass" type="password" placeholder="支付密码"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item prop="code" label="短信验证码:" label-width="100px">
					<el-input class="codeInput" style="width: 127px;margin-right: 15px;" placeholder="请输入验证码" v-model="dataForm.code"></el-input>
					<el-button type="info" style="padding: 0; border:none;" @click="sendCode" v-show="isShow">发送验证码</el-button>
					<el-button type="info" :disabled="false" v-show="!isShow" style="padding: 0;width: 100px;height: 34px;line-height: 34px;">{{secondsCount}}秒</el-button>
				</el-form-item>
			</el-col>
		</el-row>
		<el-row type="flex" justify="space-between">
			<el-form-item label="验证码：" prop="verificationCode" v-show="true">
				<el-col :span="8">
					<el-input v-model="dataForm.verificationCode" :placeholder="$t('login.captcha')">
						<span slot="prefix" class="el-input__icon">
							<svg class="icon-svg" aria-hidden="true">
								<use xlink:href="#icon-safetycertificate"></use>
							</svg>
						</span>
					</el-input>
				</el-col>
				<el-col :span="7" class="login-captcha">
					<img :src="captchaPath" @click="getCaptcha()" style="width:100%;height:100%;margin-top:-10px;margin-left:10px">
				</el-col>
			</el-form-item>
		</el-row>



    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()" :disabled="isflag">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { clearLoginInfo } from '@/utils'
import aesJs from '../../../utils/login-aes'
import {
  getUUID
} from '@/utils'
export default {
  data () {
    return {
		parentIsErr:false,
		payFormData:[],
		visible: false,
		secondsCount: 0,//倒计秒数初始化定义
		isShow: true,  //是否显示发送验证码按钮
		isflag:false, //提交
		timer:'',//定时器
		ids:[],
		captchaPath:'',//验证码
		dataForm: {
			paypass: '',
			code: '',
			payRemark:'',
			verificationCode:'',//验证码
			uuid:''
		}
    }
  },
  computed: {
    dataRule () {
      return {
      			code: [
					{ required: true, message: '请输入验证码', trigger: 'blur' }
				],
				verificationCode:[
					{ required: true, message: '验证码', trigger: 'blur' }
				],
        paypass: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
	  init () {
		  this.getCaptcha();
		  this.visible = true;
		  this.$nextTick(() => {
		    this.$refs['dataForm'].resetFields()
		  })
	  },
	 getPayDetails(){
         this.$http.post(`/sys/plat/deal/approval/getSinglePaymentInformation`,this.ids).
			 then((res)=>{
             if(res.data.code == 0){
				this.payFormData = res.data.data
			 }
		 })
	 },
	 // 获取验证码
	getCaptcha () {
		this.dataForm.uuid = getUUID()
		this.captchaPath = `${window.SITE_CONFIG['apiURL']}/sys/plat/deal/approval/getVerificationCode?uuid=${this.dataForm.uuid}`
	},
	sendCode() {
	    //发送短信验证

	    this.$http.post("sys/plat/deal/approval/pay-send-code",{
	    	headers: {
	    		'content-type': 'application/json;charset=UTF-8'
	    	}
	    }).then(res => {
	        // 倒计时
	    	if (res.data.code == 0) {
	    		let that = this
	    		// console.log(that)
	    		that.secondsCount = 60
	    		// 切换倒计时按钮
	    		that.isShow = false
	    		// 倒计时函数
	    		that.timer = setInterval(function () {
	    		    that.secondsCount--
	    		    if (that.secondsCount <= 0) {
	    		        clearInterval(that.timer)
	    		        that.isShow = true
	    		    }
	    		}, 1000)
	    	} else {
	    		this.$message.error(res.data.msg)
	    	}
	    })
	},
	cancel(){
		this.visible = false
		// this.secondsCount = 60
		// clearInterval(this.timer)
		// this.isShow = true
	},
	closeDialog(){ //关闭弹窗
		this.visible = false
		// this.secondsCount = 60
		// clearInterval(this.timer)
		// this.isShow = true
	},
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
		}
		this.isflag=true
		let url = "/sys/plat/deal/approval/pay";
        let paramsForm = JSON.parse(JSON.stringify(this.dataForm));
        paramsForm.paypass = aesJs.encrypt(paramsForm.paypass)
        this.$http.post(url, {ids:this.ids,...paramsForm}).then(({ data: res }) => {
			// this.dataForm.paypass = aesJs.decrypt(this.dataForm.paypass)
          if (res.code !== 0) {
			  this.getCaptcha();
			this.isflag=false
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            // duration: 500,
            onClose: () => {
			  this.closeDialog();
			  this.isflag=false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
